import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent, Datepicker } from '@ibsys/kit';

type Props = {
  dateFrom: string;
  dateTo: string;
  onChangePeriod: (dateFrom: string, dateTo: string) => void;
  onReset: () => void;
};

/**
 * Панель фильтров дашборда Ренессанс: период (диапазон дат одним пикером)
 * и кнопка полного сброса всех фильтров страницы.
 */
export const RenessansFilters: FC<Props> = ({ dateFrom, dateTo, onChangePeriod, onReset }) => {
  const { t } = useTranslation('renessansDashboard');

  return (
    <Card>
      <CardContent className="p-4 flex flex-col gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 items-end">
          <Datepicker
            mode="range"
            label={t('filters.period')}
            value={{ from: dateFrom, to: dateTo }}
            outputType="iso-date"
            onChange={(v) => {
              // В range-режиме приходит объект { from?, to? }; пустые значения нормализуем в ''
              if (v && typeof v === 'object') {
                onChangePeriod(v.from ?? '', v.to ?? '');
              }
            }}
          />
        </div>
        <div className="flex flex-wrap gap-2 justify-end">
          <Button variant="secondary" size="sm" onClick={onReset}>
            {t('filters.reset')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
